import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function LostReasonDialog({ open, onCancel, onConfirm }) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (open) setReason("");
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent data-testid="lost-reason-dialog">
        <DialogHeader>
          <DialogTitle>Why was this lead lost?</DialogTitle>
          <DialogDescription>A reason is required for Closed Lost.</DialogDescription>
        </DialogHeader>
        <Textarea data-testid="lost-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Budget mismatch, bought elsewhere" />
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="lost-reason-cancel">Cancel</Button>
          <Button disabled={!reason.trim()} onClick={() => onConfirm(reason.trim())} data-testid="lost-reason-confirm">Mark as lost</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
